import {Component, OnInit} from '@angular/core';
import {Utils} from '../../../../common/services/Utils';
import {CommonService} from '../../../shared/services/common.service';
import {Principal} from '../../../../common/services/principal';
import {EsuvoOptionService} from '../../../shared/services/esuvo-option.service';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PagesServiceShared} from '../../services/pages-shared.service';
import {DomSanitizer} from '@angular/platform-browser';
import {EmbedVideoService} from 'ngx-embed-video';
import {Page} from '../../../moderator/components/add-edit-page/model/page';
import {LangChange} from '../../../../lang-change';
import {Language} from '../../../../common/models/language';
import {PagesService} from '../../../moderator/services/pages.service';
import {FileService} from "../../../shared/services/file.service";

@Component({
  selector: 'app-page-layout',
  templateUrl: './page-layout.component.html',
  styleUrls: ['./page-layout.component.scss']
})
export class PageLayoutComponent extends LangChange implements OnInit {
  isModerator: boolean = false;
  isPagePreview: boolean = false;
  pageId: number;
  page: Page;
  pageTitle: string;
  pageAuthorName: string;
  pageTags: any[];
  pageContent: string;
  pageDate: Date;
  pageImage: string;
  pageImageLink: string;
  pageVideoLink: string;
  pageVideoIframeHtml: any;

  constructor(private _commonService: CommonService,
              public _translateService: TranslateService,
              private _utils: Utils,
              private sanitizer: DomSanitizer,
              private embedService: EmbedVideoService,
              private route: ActivatedRoute,
              private router: Router,
              private _footerService: EsuvoOptionService,
              private _principal: Principal,
              private _pagesService: PagesService,
              private pagesService: PagesServiceShared,
              private fileService: FileService) {
    super(_translateService);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.pageId = +params['pageId'];
      if (this.pageId === null || typeof this.pageId === undefined) {
          this.router.navigate(['/']);
      } else {
        //preview
        if (params['pageId'] === 'preview') {
          let pageReview = this._pagesService.getPreviewPageContent();
          if (pageReview) {
            this.isPagePreview = true;
            this.reloadPreview();
          }
        } else {
          this.isPagePreview = false;
          this.loadPageContent();
        }
      }
    });
  }

  onLangChange(language: Language): void {
    if (this.isPagePreview) {
      this.reloadPreview();
    } else {
      this.loadPageContent();
    }
  }

  loadPageContent() {
    this._utils.blockStart(null);

    if (this._principal.isLoggedIn()) {
      this._pagesService.checkUserHasRights(this.pageId).subscribe(data => {
        if (data['hasRights']) {
          this.isModerator = this._principal.isModerator();
        } else {
          this.isModerator = false;
        }
      });
    }

    this.pagesService.getPageContent(this.pageId).subscribe(data => {
      if (data) {
        if (data) {
          this.page = data;
          this.getPageData(data);
        }
      }
    }, error => {
      this._utils.notifyError('loadPageContent error!', null);
      console.log('error', error);
    });
    setTimeout(() => {
      this._utils.blockStop();
    }, 1000);
  }

  getPageData(data) {
    switch (this._translateService.currentLang) {
      case 'kz':
        return this.getPageDataByLang('Kz', data);
      case 'ru':
        return this.getPageDataByLang('Ru', data);
      case 'en':
        return this.getPageDataByLang('En', data);
    }
  }

  getPageDataByLang(lang: string, data: any) {
    this.pageTitle = data['name' + lang];
    this.pageAuthorName = data.authorName;
    this.pageTags = data['pageTags' + lang];
    this.pageContent = data['pageContent' + lang];
    if (data['pageImageId' + lang]) {
      this.pageVideoLink = null;
      this.pageVideoIframeHtml = null;
      this.pageImage = data['pageImageId' + lang];
      if (this.isPagePreview) {
        this.fileService.getFile(this.pageImage).subscribe(data => {
          this.pageImageLink = window.URL.createObjectURL(new Blob([data], {type: data.type}));
        }, error => {
          console.log('getFile error', error);
        });
      } else {
        this.pagesService.getPageImage(data.id, this.pageImage).subscribe(data => {
          this.pageImageLink = window.URL.createObjectURL(new Blob([data], {type: data.type}));
        }, error => {
          console.log('getFile error', error);
        });
      }
    } else if (data['pageVideoLink' + lang]) {
      this.pageImage = null;
      this.pageVideoLink = data['pageVideoLink' + lang];
      this.pageVideoIframeHtml = this.embedService.embed(this.pageVideoLink);
    } else if (!data['pageImageId' + lang] && !data['pageVideoLink' + lang]) {
      this.pageImage = null;
      this.pageVideoLink = null;
    }
    this.pageDate = data.createDate;
  }

  sanitize(url: string) {
    if (this.isPagePreview && this.pageImage === this.pageImageLink) {
      return url;
    } else {
      return this.sanitizer.bypassSecurityTrustUrl(url);
    }
  }

  editPage() {
    if (this.pageId && this.page.sectionId) {
      this.router.navigate(['moderator/add-edit-page/' + this.page.sectionId + '/' + this.pageId]);
    }
  }

  disablePage() {
    if (this.pageId && this.isModerator) {
      this._utils.confirmDialog({message: 'page_add_edit.are_sure_to_disable'}, () => {
        this._pagesService.disblePage(this.pageId).subscribe(resp => {
          if (resp.status === 'SUCCESS') {
            this._utils.notifySaved(true);
          } else {
            this._utils.notifySaved(false);
            // console.log(resp.message);
          }
        }, error => {
          this._utils.notifyDeleted(false);
          console.log(error);
        });
      });
    }
  }

  deletePage() {
    if (this.pageId && this.isModerator) {
      this._utils.confirmDialog(null, () => {
        this._pagesService.deletePage(this.pageId).subscribe(resp => {
          if (resp.status === 'SUCCESS') {
            this._utils.notifyDeleted(true);
            window.location.href = '/';
          } else {
            this._utils.notifyDeleted(false);
            // console.log(resp.message);
          }
        }, error => {
          this._utils.notifyDeleted(false);
          console.log(error);
        });
      });
    }
  }

  reloadPreview() {
    let pagePreview = this._pagesService.getPreviewPageContent();
    if (pagePreview) {
      this.page = pagePreview;
      this.getPageData(this.page);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/page-layout/page-layout.component.ts